
const MusicWidget = {
    elements: {
        modal: null,
        openBtn: null,
        closeBtn: null,
        okBtn: null,
        muteToggle: null,
        volumeSlider: null,
        musicSelector: null,
        tabs: null // New
    },

    currentCategory: 'general', // Default category

    init: function () {
        console.log("🎵 MusicWidget Initializing...");
        this.cacheElements();
        this.bindEvents();
        this.populateMusicList();
        this.syncUI();
    },

    cacheElements: function () {
        this.elements.modal = document.getElementById('music-selection-modal');
        this.elements.openBtn = document.getElementById('header-music-btn');
        this.elements.closeBtn = document.getElementById('close-music-btn');
        this.elements.okBtn = document.getElementById('music-ok-btn');

        this.elements.muteBtn = document.getElementById('music-mute-btn'); // New
        this.elements.muteIcon = document.getElementById('music-mute-icon'); // New
        this.elements.volumeSlider = document.getElementById('music-modal-volume-slider');
        this.elements.cardsContainer = document.getElementById('music-cards-container'); // New
        this.elements.tabs = document.querySelectorAll('.tab-btn'); // New
    },

    bindEvents: function () {
        const { modal, openBtn, closeBtn, okBtn, muteBtn, volumeSlider } = this.elements;

        if (openBtn && modal) {
            openBtn.addEventListener('click', () => {
                modal.classList.remove('hidden');
                if (window.audio && window.audio.playSound) window.audio.playSound('buttons');
                this.syncUI();
            });
        }

        if (closeBtn && modal) {
            closeBtn.addEventListener('click', () => modal.classList.add('hidden'));
        }

        if (okBtn && modal) {
            okBtn.addEventListener('click', () => modal.classList.add('hidden'));
        }

        if (modal) {
            modal.addEventListener('click', (e) => {
                if (e.target === modal) modal.classList.add('hidden');
            });
        }

        // Mute Toggle (Button)
        if (muteBtn) {
            muteBtn.addEventListener('click', () => {
                const isMuted = window.audio && window.audio.isMuted;
                const newMuteState = !isMuted;

                window.audio.setMute(newMuteState);
                window.audio.playSound(newMuteState ? 'toggle_off' : 'toggle_on');

                this.syncUI();
            });
        }

        // Volume Slider with Progress Effect
        if (volumeSlider) {
            const updateProgress = () => {
                const val = (volumeSlider.value - volumeSlider.min) / (volumeSlider.max - volumeSlider.min) * 100;
                volumeSlider.style.setProperty('--progress', `${val}%`);
            };

            volumeSlider.addEventListener('input', (e) => {
                const vol = parseFloat(e.target.value);
                if (window.audio) {
                    window.audio.setMusicVolume(vol);
                }
                updateProgress();
            });

            // Initial progress
            updateProgress();
        }

        // Tab Switching
        if (this.elements.tabs) {
            this.elements.tabs.forEach(tab => {
                tab.addEventListener('click', (e) => {
                    const category = e.target.dataset.category;
                    this.currentCategory = category;
                    this.syncUI();
                });
            });
        }

        // Global keydown for ESC
        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal && !modal.classList.contains('hidden')) {
                modal.classList.add('hidden');
            }
        });
    },

    populateMusicList: function () {
        const container = this.elements.cardsContainer;
        if (container && window.audio && window.audio.musicList) {
            container.innerHTML = '';

            // Filter by category
            const filteredList = window.audio.musicList.filter(track => track.category === (this.currentCategory || 'general'));

            filteredList.forEach(track => {
                const card = document.createElement('div');
                card.className = 'music-card';
                card.dataset.file = track.file;

                // Active state check
                const isCurrent = (window.audio.musicMode === 'custom' && window.audio.customTrack === track.file) ||
                    (window.audio.musicMode === 'default' && track.file === 'default');

                if (isCurrent) card.classList.add('active');

                card.innerHTML = `
                    <div class="music-icon">🎵</div>
                    <div class="music-name">${track.name}</div>
                `;

                card.addEventListener('click', () => {
                    // Update UI
                    container.querySelectorAll('.music-card').forEach(c => c.classList.remove('active'));
                    card.classList.add('active');

                    // Apply Music
                    if (track.file === 'default') {
                        window.audio.setMusicMode('default');
                    } else {
                        window.audio.setMusicMode('custom', track.file);
                    }
                });

                container.appendChild(card);
            });
        }
    },

    syncUI: function () {
        if (!window.audio) return;

        const { volumeSlider, muteIcon, muteBtn } = this.elements;

        // Sync Mute Icon
        if (muteIcon) {
            muteIcon.innerText = window.audio.isMuted ? '🔇' : '🔊';
        }
        if (muteBtn) {
            muteBtn.classList.toggle('active', !window.audio.isMuted);
        }

        // Sync Music Tabs
        const tabs = document.querySelectorAll('.tab-btn');
        tabs.forEach(tab => {
            if (tab.dataset.category === this.currentCategory) {
                tab.classList.add('active', 'primary');
            } else {
                tab.classList.remove('active', 'primary');
            }
        });

        // Sync Volume Slider
        if (volumeSlider) {
            volumeSlider.value = window.audio.musicVolume;
            const val = (volumeSlider.value - volumeSlider.min) / (volumeSlider.max - volumeSlider.min) * 100;
            volumeSlider.style.setProperty('--progress', `${val}%`);
        }

        // Sync Cards
        this.populateMusicList();
    }
};

window.MusicWidget = MusicWidget;
